import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6983c7f0"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6983c7f0')) {
      api.createRecord('6983c7f0', component.options)
    } else {
      api.reload('6983c7f0', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6983c7f0", function () {
      api.rerender('6983c7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Supplier/Index.vue"
export default component.exports